import React, {FC, useState} from 'react';
import { useForm } from 'react-hook-form';
import Datepicker, { DateValueType } from 'react-tailwindcss-datepicker';

export type PromoFormData = {
    promo_code: string,
    description: string,
    discount: number,
    startDate: string | Date | null;
    endDate: string | Date | null;
};

type IPromoFormProps = {
    type: 'create' | 'update',
    defaultFormData: PromoFormData,
    onSubmit: (data: PromoFormData) => void
};


const PromotionAdminForm: FC<IPromoFormProps> = ({type, defaultFormData, onSubmit}) => {
    const { register, handleSubmit, setValue } = useForm<PromoFormData>({defaultValues: defaultFormData});

    const [calendarDate, setCalendarDate] = useState < DateValueType > (null);

    // evt handlers
    // evt handlers
    const handleValueChange = (newValue : DateValueType) => {        
        setValue('startDate', newValue?.startDate??'');
        setValue('endDate', newValue?.endDate??'');
        setCalendarDate(newValue);
    };

    const onFormSubmit = (formData: PromoFormData) => {
        // validation
        const isNotEmpty =  Object.values(formData).every(value => value !== undefined && value !== '');        
        if (!isNotEmpty || !formData.startDate || !formData.endDate) {
            return console.log('Error, empty fields!', formData);
        }        
        onSubmit(formData);
        
    };

    return <section
    className="flex flex-row flex-wrap w-full lg:flex-nowrap justify-space-between">
    <section
        id="form-section"
        className="p-4 my-3 mr-3 bg-white shadow-lg grow rounded-xl dark:bg-gray-900">
        <form 
            onSubmit={handleSubmit(onFormSubmit)}
            className="flex flex-wrap w-full mb-6">
            {/* First Row */}
            <div className="w-full px-3 mb-6 md:mb-0">
                <label
                    className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase dark:text-teal-400"
                    htmlFor="form-promo-code">
                    Promo Code*
                </label>
                <input
                    required
                    {...register('promo_code')}
                    className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border-2 border-blue-200 rounded appearance-none dark:border-teal-700 focus:outline-none focus:bg-white"
                    id="form-promo-code"
                    type="text"
                    placeholder="promo_code_snake_case_format"/>
                <p className="hidden text-xs italic text-red-500">Required</p>
            </div>
            {/* Second Row */}
            <div className="w-full px-3">
                <label
                    className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase dark:text-teal-400"
                    htmlFor="form-description">
                    Description*
                </label>
                <textarea
                    required
                    {...register('description')}
                    id="form-description"
                    rows={4}
                    cols={10}
                    className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border-2 border-blue-200 rounded appearance-none dark:border-teal-700 focus:outline-none focus:bg-white"
                    placeholder="Promo offer details description..."/>
            </div>
            {/* Third Row */}
            <div className="w-full px-3 mb-6 md:w-1/2 lg:w-1/4 md:mb-0">
                <label
                    className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase dark:text-teal-400"
                    htmlFor="form-discount">
                    Discount (%)
                </label>
                <input
                    required
                    {...register('discount')}
                    className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border-2 border-blue-200 rounded appearance-none dark:border-teal-700 focus:outline-none focus:bg-white"
                    id="form-discount"
                    type="text"                                
                    placeholder="50.0"/>
                <p className="hidden text-xs italic text-red-500">Required</p>
            </div>            
            {/* Fourth Row */}
            <div className="w-full px-3 mb-6 md:mb-0">
                <label
                    className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase dark:text-teal-400"
                    htmlFor="grid-first-name">
                    Select Start Date & End Date*
                </label>
                <Datepicker                                
                    inputClassName="border-2 border-blue-200 dark:border-teal-700"
                    value={calendarDate}
                    onChange={handleValueChange}
                    showShortcuts={true}/>
            </div>
            {/* Submit button */}
            <button
                type='submit'                            
                className="px-4 py-2 mx-3 my-6 font-bold text-white bg-blue-500 border-b-4 border-blue-700 rounded hover:bg-blue-400 hover:border-blue-500">
                {type === 'create' ? 'Create Promotion' : 'Update Promotion'}
            </button>
            <button
                type='reset'
                className="px-4 py-2 mx-3 my-6 font-bold text-gray-700 bg-gray-300 border-b-4 border-gray-500 rounded hover:bg-gray-400 hover:text-white hover:border-gray-700">
                Cancel
            </button>
        </form>
    </section>    
</section>
};

export default PromotionAdminForm;